import moment from "moment";

const separationCards = (cards) => {
  let one = [];
  let two = [];
  let three = [];
  let four = [];
  let five = [];
  let six = [];
  let seven = [];
  let eight = [];
  let nine = [];
  cards.forEach((card) => {
    if (card["learningLevel"] == 1) one.push(card);
    if (card["learningLevel"] == 2) two.push(card);
    if (card["learningLevel"] == 3) three.push(card);
    if (card["learningLevel"] == 4) four.push(card);
    if (card["learningLevel"] == 5) five.push(card);
    if (card["learningLevel"] == 6) six.push(card);
    if (card["learningLevel"] == 7) seven.push(card);
    if (card["learningLevel"] == 8) eight.push(card);
    if (card["learningLevel"] == 9) nine.push(card);
  });
  const totalCards = { one, two, three, four, five, six, seven, eight, nine };
  return totalCards;
};

const answerCard = (orgCard, cardLevel, answerLevel, allCards) => {
  let card = { ...orgCard };
  let newLevel, newNumLevel;
  let oldLevel;
  //عدد  10 برای ده دقیقه است و بقیه بر حسب روز می باشند
  if (answerLevel == 0) {
    newLevel = "one";
    newNumLevel = 1;
  } else if (answerLevel == 10) {
    newLevel = "two";
    newNumLevel = 2;
  } else if (answerLevel == 1) {
    newLevel = "three";
    newNumLevel = 3;
  } else if (answerLevel == 2) {
    newLevel = "four";
    newNumLevel = 4;
  } else if (answerLevel == 4) {
    newLevel = "five";
    newNumLevel = 5;
  } else if (answerLevel == 8) {
    newLevel = "six";
    newNumLevel = 6;
  } else if (answerLevel == 16) {
    newLevel = "seven";
    newNumLevel = 7;
  } else if (answerLevel == 30) {
    newLevel = "eight";
    newNumLevel = 8;
  } else if (answerLevel == 60) {
    newLevel = "nine";
    newNumLevel = 9;
  } else if (answerLevel == "done") {
    newLevel = "ten";
    newNumLevel = 10;
  }

  if (cardLevel == 1) oldLevel = "one";
  else if (cardLevel == 2) oldLevel = "two";
  else if (cardLevel == 3) oldLevel = "three";
  else if (cardLevel == 4) oldLevel = "four";
  else if (cardLevel == 5) oldLevel = "five";
  else if (cardLevel == 6) oldLevel = "six";
  else if (cardLevel == 7) oldLevel = "seven";
  else if (cardLevel == 8) oldLevel = "eight";
  else if (cardLevel == 9) oldLevel = "nine";
  else if (cardLevel == 10) oldLevel = "ten";

  let newAllcards = { ...allCards };

  // let index = newAllcards[oldLevel].indexOf(card);
  let index;
  newAllcards[oldLevel].forEach((el, idx) => {
    if (orgCard["_id"] == el["_id"]) index = idx;
  });
  if (index > -1) {
    newAllcards[oldLevel].splice(index, 1);
  }
  card["learningLevel"] = newNumLevel;
  if (newLevel == "one" || newLevel == "two") {
    card["updatedAt"] = moment().toDate();
    newAllcards[newLevel].push(card);
  }
  return { card, newAllcards };
};

const pickNewCard = (allCards) => {
  let pickedCard = false;
  if (allCards["nine"].length > 0) {
    pickedCard = allCards["nine"][0];
  } else if (allCards["eight"].length > 0) {
    pickedCard = allCards["eight"][0];
  } else if (allCards["seven"].length > 0) {
    pickedCard = allCards["seven"][0];
  } else if (allCards["six"].length > 0) {
    pickedCard = allCards["six"][0];
  } else if (allCards["five"].length > 0) {
    pickedCard = allCards["five"][0];
  } else if (allCards["four"].length > 0) {
    pickedCard = allCards["four"][0];
  } else if (allCards["three"].length > 0) {
    pickedCard = allCards["three"][0];
  } else if (allCards["two"].length > 0) {
    pickedCard = allCards["two"][0];
    let timeCard = moment(pickedCard["updatedAt"]);
    let timeNow = moment();
    let diffTime = timeNow.diff(timeCard, "minutes");
    if (diffTime > 10) {
    } else if (allCards["one"].length > 0) {
      pickedCard = allCards["one"][0];
    } else {
      pickedCard = false;
    }
  } else if (allCards["one"].length > 0) {
    pickedCard = allCards["one"][0];
  }
  return pickedCard;
};
const returnAnswerLevel = (card) => {
  let answerLevels = { veryHard: 0, hard: 10, medium: 1, easy: 2 };
  if (card["learningLevel"] == 1)
    answerLevels = { veryHard: 0, hard: 10, medium: 1, easy: 2 };
  else if (card["learningLevel"] == 2)
    answerLevels = { veryHard: 0, hard: 10, medium: 1, easy: 2 };
  else if (card["learningLevel"] == 3)
    answerLevels = { veryHard: 0, hard: 10, medium: 1, easy: 2 };
  else if (card["learningLevel"] == 4)
    answerLevels = { veryHard: 0, hard: 10, medium: 2, easy: 4 };
  else if (card["learningLevel"] == 5)
    answerLevels = { veryHard: 0, hard: 1, medium: 4, easy: 8 };
  else if (card["learningLevel"] == 6)
    answerLevels = { veryHard: 0, hard: 2, medium: 8, easy: 16 };
  else if (card["learningLevel"] == 7)
    answerLevels = { veryHard: 0, hard: 4, medium: 16, easy: 30 };
  else if (card["learningLevel"] == 8)
    answerLevels = { veryHard: 0, hard: 8, medium: 16, easy: 60 };
  else if (card["learningLevel"] == 9)
    answerLevels = { veryHard: 0, hard: 30, medium: 60, easy: "done" };
  return answerLevels;
};

const handleDeleteCard = (orgCard, allCards) => {
  let cardLevel;
  let cardGroup = orgCard["learningLevel"];
  if (cardGroup == 1) cardLevel = "one";
  else if (cardGroup == 2) cardLevel = "two";
  else if (cardGroup == 3) cardLevel = "three";
  else if (cardGroup == 4) cardLevel = "four";
  else if (cardGroup == 5) cardLevel = "five";
  else if (cardGroup == 6) cardLevel = "six";
  else if (cardGroup == 7) cardLevel = "seven";
  else if (cardGroup == 8) cardLevel = "eight";
  else if (cardGroup == 9) cardLevel = "nine";
  else if (cardGroup == 10) cardLevel = "ten";

  let newAllcards = { ...allCards };
  let index;
  newAllcards[cardLevel].forEach((el, idx) => {
    if (orgCard["_id"] == el["_id"]) index = idx;
  });
  if (index > -1) {
    newAllcards[cardLevel].splice(index, 1);
  }
  return newAllcards;
};

export {
  separationCards,
  answerCard,
  pickNewCard,
  returnAnswerLevel,
  handleDeleteCard,
};
